import React from 'react'
import { Row, Col, Popover, Button, Avatar } from 'antd'
import ModelGenIcon from '@assets/Logos/model-generated-icon.svg'
import UserIcon from '@assets/CustomIcons/user_edited.svg'
import moment from 'moment'
import { UserOutlined } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import BBDLogo from '@assets/Logos/bbd-logo.svg'
const iconStyles = {
  width: 24,
  height: 24,
}
type UpdatedTagProps = {
  created?: { by: string; date: string }
  updated: { by: string; date: string }
  title: string
}
export const UpdatedTag = ({ created, updated, title }: UpdatedTagProps) => {
  const showModelGen = !created && !updated
  const hasBeenUpdated = !!updated
  const date = created?.date ? created.date : hasBeenUpdated ? updated.date : created?.date

  return (
    <Popover
      content={<UpdateDetails created={created} updated={updated} />}
      title={<UpdateTitle title={title} />}
      trigger='hover'
      placement='leftTop'
    >
      <div>
        <Horizontal className='order-stat-tag-container' style={{ flexWrap: 'nowrap', minWidth: 'fit-content' }}>
          {showModelGen ? (
            <Vertical
              verticalCenter
              borderRadius='6px 0 0 6px'
              flex='0'
              style={{
                overflow: 'visible',
                height: 20,
                background: 'var(--theme-color-2)',
              }}
            >
              <img className='p-1' src={BBDLogo} style={iconStyles} alt='Gravitate' />
            </Vertical>
          ) : (
            <Vertical
              verticalCenter
              bg='info'
              border='all'
              borderRadius='6px 0 0 6px'
              flex='0'
              style={{ overflow: 'visible', height: 20 }}
            >
              <Texto category='label' appearance='secondary' weight='600' style={{ fontSize: '12px' }}>
                <UserOutlined className='px-2 py-2' />
              </Texto>
            </Vertical>
          )}

          <Vertical
            bg='elevated'
            border='all'
            borderRadius='0 6px 6px 0'
            flex={1}
            style={{ height: 20 }}
            className=' px-2 vertical-flex-center h-100'
          >
            <Texto
              category='label'
              style={{
                fontWeight: hasBeenUpdated ? 'bold' : 'normal',
                flexWrap: 'nowrap',
              }}
            >
              {formatters.SHORT_DATE_TIME(moment(date))}
            </Texto>
          </Vertical>
        </Horizontal>
      </div>
    </Popover>
  )
}
export const UpdateDetails = ({
  created,
  updated,
  ignoreCreatedIfNull = false,
}: {
  created?: { by: string; date: string }
  updated: { by: string; date: string }
  ignoreCreatedIfNull?: boolean
}) => {
  return (
    <div style={{ minWidth: 300 }}>
      {ignoreCreatedIfNull && !created?.by ? null : (
        <Horizontal>
          <Vertical flex={2} gap='4px'>
            <Texto category='label' weight='600' className='popover-subtitle'>
              Created By
            </Texto>
            <Row className='popover-icon' align='top'>
              {!created?.by ? (
                <Avatar
                  size={24}
                  style={{
                    overflow: 'visible',
                    background: 'var(--theme-color-2)',
                  }}
                >
                  <img src={BBDLogo} alt='Gravitate' style={iconStyles} />
                </Avatar>
              ) : (
                <Avatar
                  size={24}
                  style={{
                    overflow: 'visible',
                    background: 'var(--theme-color-2-dim)',
                    color: 'var(--theme-color-1)',
                    border: 'solid 1px var(--gray-300)',
                  }}
                >
                  <UserOutlined />
                </Avatar>
              )}
              <Texto category='p1' className='popover-status-text'>
                {created?.by ? created.by : 'Gravitate'}
              </Texto>
            </Row>
          </Vertical>
          <Vertical style={{ overflow: 'visible' }} gap='4px' flex={1} alignItems='flex-end'>
            <Texto className='popover-subtitle' category='label' weight='600'>
              At
            </Texto>
            <Texto style={{ whiteSpace: 'nowrap' }} category='p1' className='popover-status-text pl-2'>
              {created?.date ? formatters.WEEKDAY_MONTH_DATE_TIME(moment(created.date)) : ''}
            </Texto>
          </Vertical>
        </Horizontal>
      )}
      {(updated.by || updated.date) && (
        <Horizontal>
          <Vertical gap='4px' flex={2} style={{ overflow: 'visible' }}>
            <Texto category='label' weight='600' className='popover-subtitle'>
              Last Updated By
            </Texto>
            <Row className='popover-icon' align='top'>
              <Avatar
                size={24}
                style={{
                  overflow: 'visible',
                  background: 'var(--theme-color-2-dim)',
                  color: 'var(--theme-color-1)',
                  border: 'solid 1px var(--gray-300)',
                }}
              >
                <UserOutlined />
              </Avatar>
              <Texto category='p1' className='popover-status-text'>
                {updated.by}
              </Texto>
            </Row>
          </Vertical>

          <Vertical gap='4px' flex={1} alignItems='flex-end' style={{ overflow: 'visible' }}>
            <Texto category='label' className='popover-subtitle' weight='600'>
              At
            </Texto>
            <Texto style={{ whiteSpace: 'nowrap' }} category='p1' className='popover-status-text pl-2'>
              {updated.date ? formatters.WEEKDAY_MONTH_DATE_TIME(moment(updated.date)) : ''}
            </Texto>
          </Vertical>
        </Horizontal>
      )}
    </div>
  )
}
const UpdateTitle = ({ title }: { title: string }) => {
  return (
    <Horizontal verticalCenter>
      <Col flex={1}>
        <div className='popover-title'>{title}</div>
      </Col>
    </Horizontal>
  )
}
